module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/es-b3825b28f7a64779d80d6a5da10cfa08.svg";